import { render } from "./ProductListSolutions.vue?vue&type=template&id=13aa3b3f"
import script from "./ProductListSolutions.vue?vue&type=script&lang=js"
export * from "./ProductListSolutions.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__